import { requestConstantsMaker } from '../helper';

export const GET_ALL_COURSE = requestConstantsMaker('GET_ALL_COURSE');
export const GET_COURSE = requestConstantsMaker('GET_COURSE');